sew-ws-product-info {
    @include grid;

    > h1 {
        @include typo-ws-h1;

        // 80px - 16px of breadcrumb
        margin-top: 64px;
        grid-column: 2 / span 7;
        margin-bottom: 0;
    }

    > p {
        @include typo-ws-paragraph;

        grid-column: 2 / span 7;
        margin-top: 32px;
        margin-bottom: 0;
    }

    .image-wrapper {
        margin-top: 60px;

        > sew-picture {
            display: block;
            width: 100%;
        }
    }

    [slot='information'],
    [slot='advantage'] {
        display: block;
        margin-top: 40px;
    }
}

@include mq-4-min {
    sew-ws-product-info {
        .left-area {
            grid-column: 2 / span 8;

            [slot='information'] {
                display: block;
                padding-left: 0;
            }
        }

        .right-area {
            grid-area: 3 / 10 / auto / -2;

            sew-ws-richtext {
                padding-right: 0;
            }

            sew-ws-linklist {
                margin-top: 44px;
                padding-right: 0;
            }
        }
    }
}

@include mq-3-only {
    sew-ws-product-info {
        .left-area {
            grid-column: 1 / span 9;

            [slot='information'] {
                display: block;
                padding-left: var(--grid-margin);
            }
        }

        .right-area {
            grid-area: 3 / 10 / auto / -1;

            sew-ws-richtext {
                padding-right: var(--grid-margin);
            }

            sew-ws-linklist {
                margin-top: 44px;
                padding-right: var(--grid-margin);
            }
        }
    }
}

@include mq-2-min {
    sew-ws-product-info {
        sew-ws-cta,
        sew-ws-animated-numbers {
            margin-left: calc(var(--column-gap) * -1);
        }
    }
}

@include mq-2 {
    sew-ws-product-info {
        // 60px - 16px of breadcrumb
        > h1 {
            margin-top: 44px;
        }

        p {
            margin-top: 24px;
        }

        > h1,
        > p {
            grid-column: 2 / span 12;
        }

        .left-area,
        .right-area {
            display: contents;
        }
        .image-wrapper {
            grid-column: 1 / span 8;
            margin-top: 120px;
        }

        [slot='cta'] {
            display: block;
            grid-area: 3 / 9 / 4 / -1;
            align-self: start;
            margin-top: 60px;
        }

        [slot='advantage'] {
            display: block;
            grid-area: 5 / 2 / auto / -2;
        }

        [slot='information'] {
            display: block;
            grid-area: 6 / 2 / auto / -2;
            margin-top: 20px;
        }

        [slot='links'] {
            display: block;
            grid-area: 7 / 2 / auto / -2;
            margin-top: 60px;
        }
    }
}

@include mq-1 {
    sew-ws-product-info {
        // 40px - 16px of breadcrumb
        > h1 {
            margin-top: 24px;
        }
        > p {
            margin-top: 16px;
        }

        .image-wrapper {
            grid-area: 3 / 2 / auto / -2;
            margin-top: 32px;

            p {
                padding: 12px 0 0;
            }
        }

        [slot='cta'] {
            display: block;
            margin-top: 40px;
            grid-area: 4 / 2 / auto / -2;
        }
    }
}
